module.exports = __webpack_public_path__ + "static/media/pic16.5623e0aa.jpg";